@if (locations) {
  <div class="select-holder">
    <select (change)="selectLocation()" [(ngModel)]="filter">
      <option [ngValue]="undefined">{{'filterLocationDefault' | translate}}</option>
      @for (location of locations | orderBy: '+'; track location) {
        @if ((jobs | search: 'location.city':location | numberOfKeys ) !== 0) {
          @if (location) {
            <option [value]="location">
              {{location}} <span>({{jobs | search: 'location.city':location | numberOfKeys}})</span>
            </option>
          }
        }
      }
      @for (location of locations | orderBy: '+'; track location) {
        @if ((jobs | search: 'location.city':location | numberOfKeys ) !== 0) {
          @if (!location) {
            <option [value]="location">
              {{'noOffice' | translate}} <span>({{jobs | search: 'location.city':location | numberOfKeys}})</span>
            </option>
          }
        }
      }
    </select>
  </div>
}
